(function () {
  const SUFFIX = "ember-grid-coffee-v1";
  const LAYOUT_ID = "CollectionFilteredLayout";
  const PANEL_ID = "CollectionFilterPanel";
  const MOBILE_MQ = "(max-width: 800px)";

  function isCoffeeTemplate() {
    return document.documentElement.classList.contains("template-suf-" + SUFFIX);
  }

  function parseList(card, name) {
    const raw = card.dataset[name];
    if (raw == null || raw === "" || raw === "null") return [];
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed.filter(function (v) {
          return v != null && String(v) !== "";
        }).map(String);
      }
      if (parsed == null) return [];
      return [String(parsed)];
    } catch (err) {
      return [String(raw)];
    }
  }

  function parseScalar(card, name) {
    const raw = card.dataset[name];
    if (raw == null || raw === "" || raw === "null") return null;
    const value = parseFloat(raw);
    if (Number.isNaN(value)) return null;
    return value;
  }

  function getCheckedValues(panel, name) {
    return Array.from(panel.querySelectorAll('input[type="checkbox"][name="' + name + '"]:checked')).map(
      function (input) {
        return input.value;
      }
    );
  }

  function checkboxNames(panel) {
    const names = [];
    panel.querySelectorAll('input[type="checkbox"][name]').forEach(function (input) {
      if (names.indexOf(input.name) === -1) names.push(input.name);
    });
    return names;
  }

  function EmberCollectionFilters(root) {
    this.layout = root;
    this.panel = document.getElementById(PANEL_ID);
    this.cards = Array.from(root.querySelectorAll(".ember-filterable"));
    this.results = root.parentElement
      ? root.parentElement.querySelector("[data-ember-filter-results]")
      : null;
    if (!this.results && this.panel) {
      this.results = this.panel.querySelector("[data-ember-filter-results]");
    }
    this.empty = root.querySelector(".ember-filter-empty");
    this.trigger = document.querySelector(".ember-filter-trigger");
    this.skipHistory = false;
    this.prevFocus = null;
    this.boundKeydown = this.onKeydown.bind(this);

    if (!this.panel) return;

    this.init();
  }

  EmberCollectionFilters.prototype.init = function () {
    const self = this;
    this.shell = this.layout.closest(".collection-content") || this.layout;

    if (this.trigger) {
      this.trigger.addEventListener("click", function (event) {
        event.preventDefault();
        if (self.layout.classList.contains("filters-active")) {
          self.closePanel();
        } else {
          self.openPanel();
        }
      });
    }

    this.panel.querySelectorAll(".ember-filter-close").forEach(function (button) {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        self.closePanel();
      });
    });

    this.panel.addEventListener("click", function (event) {
      if (event.target === self.panel && window.matchMedia(MOBILE_MQ).matches) {
        self.closePanel();
      }
    });

    const inner = this.panel.querySelector(".ember-product-filters__inner");
    if (inner) {
      inner.addEventListener("click", function (event) {
        event.stopPropagation();
      });
    }

    const form = this.panel.querySelector("[data-ember-filter-form]");
    if (form) {
      form.addEventListener("submit", function (event) {
        event.preventDefault();
      });
    }

    const clearBtn = this.panel.querySelector("[data-ember-filter-clear]");
    if (clearBtn) {
      clearBtn.addEventListener("click", function (event) {
        event.preventDefault();
        self.clearAll();
      });
    }

    this.panel.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener("change", function () {
        self.apply({ fromUser: true });
      });
    });

    this.panel.querySelectorAll(".range-slider").forEach(function (slider) {
      const minInput = slider.querySelector(".range-min");
      const maxInput = slider.querySelector(".range-max");
      if (!minInput || !maxInput) return;

      function onInput(event) {
        let min = parseFloat(minInput.value);
        let max = parseFloat(maxInput.value);
        if (event.target === minInput && min > max) {
          max = min;
          maxInput.value = String(max);
        } else if (event.target === maxInput && max < min) {
          min = max;
          minInput.value = String(min);
        }
        self.paintRangeFill(slider);
        self.apply({ fromUser: true });
      }

      minInput.addEventListener("input", onInput);
      maxInput.addEventListener("input", onInput);
    });

    window.addEventListener("popstate", function () {
      self.skipHistory = true;
      self.hydrateFromUrl();
      self.apply({ fromUser: false });
      self.skipHistory = false;
    });

    this.skipHistory = true;
    this.hydrateFromUrl();
    this.apply({ fromUser: false });
    this.skipHistory = false;
  };

  EmberCollectionFilters.prototype.isMobile = function () {
    return window.matchMedia(MOBILE_MQ).matches;
  };

  EmberCollectionFilters.prototype.focusables = function () {
    return Array.from(
      this.panel.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    ).filter(function (el) {
      return el.offsetParent !== null || el.getClientRects().length > 0;
    });
  };

  EmberCollectionFilters.prototype.openPanel = function () {
    this.layout.classList.add("filters-active");
    this.shell.classList.add("filters-active");
    document.documentElement.classList.add("stuck");
    this.panel.setAttribute("aria-hidden", "false");
    if (this.trigger) this.trigger.setAttribute("aria-expanded", "true");
    this.prevFocus = document.activeElement;
    document.addEventListener("keydown", this.boundKeydown);
    const focusables = this.focusables();
    if (focusables.length) focusables[0].focus();
  };

  EmberCollectionFilters.prototype.closePanel = function () {
    this.layout.classList.remove("filters-active");
    this.shell.classList.remove("filters-active");
    document.documentElement.classList.remove("stuck");
    this.panel.setAttribute("aria-hidden", "true");
    if (this.trigger) this.trigger.setAttribute("aria-expanded", "false");
    document.removeEventListener("keydown", this.boundKeydown);
    if (this.prevFocus && typeof this.prevFocus.focus === "function") {
      this.prevFocus.focus();
    } else if (this.trigger) {
      this.trigger.focus();
    }
  };

  EmberCollectionFilters.prototype.onKeydown = function (event) {
    if (event.key === "Escape") {
      event.preventDefault();
      this.closePanel();
      return;
    }
    if (event.key !== "Tab") return;
    const focusables = this.focusables();
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  };

  EmberCollectionFilters.prototype.rangeState = function () {
    const ranges = {};
    this.panel.querySelectorAll(".range-slider").forEach(function (slider) {
      const name = slider.dataset.name;
      const minInput = slider.querySelector(".range-min");
      const maxInput = slider.querySelector(".range-max");
      if (!name || !minInput || !maxInput) return;
      const min = parseFloat(minInput.value);
      const max = parseFloat(maxInput.value);
      const minLimit = parseFloat(minInput.min);
      const maxLimit = parseFloat(minInput.max);
      if (min === minLimit && max === maxLimit) return;
      ranges[name] = [min, max];
    });
    return ranges;
  };

  EmberCollectionFilters.prototype.checkboxState = function () {
    const self = this;
    const selected = {};
    checkboxNames(this.panel).forEach(function (name) {
      const values = getCheckedValues(self.panel, name);
      if (values.length) selected[name] = values;
    });
    return selected;
  };

  EmberCollectionFilters.prototype.passesCheckboxGroup = function (card, name, selected) {
    if (!selected || selected.length === 0) return true;
    const values = parseList(card, name);
    if (values.length === 0) return true;
    return selected.some(function (value) {
      return values.indexOf(value) !== -1;
    });
  };

  EmberCollectionFilters.prototype.passesSliderGroup = function (card, name, range) {
    if (!range) return true;
    const value = parseScalar(card, name);
    if (value == null) return true;
    return value >= range[0] && value <= range[1];
  };

  EmberCollectionFilters.prototype.cardPasses = function (card, checkboxes, ranges, skipGroup) {
    const self = this;
    let visible = true;
    Object.keys(checkboxes).forEach(function (name) {
      if (name === skipGroup) return;
      if (!self.passesCheckboxGroup(card, name, checkboxes[name])) visible = false;
    });
    if (!visible) return false;
    Object.keys(ranges).forEach(function (name) {
      if (name === skipGroup) return;
      if (!self.passesSliderGroup(card, name, ranges[name])) visible = false;
    });
    return visible;
  };

  EmberCollectionFilters.prototype.apply = function (opts) {
    const fromUser = opts && opts.fromUser;
    const checkboxes = this.checkboxState();
    const ranges = this.rangeState();
    let visibleCount = 0;
    const self = this;

    this.cards.forEach(function (card) {
      const visible = self.cardPasses(card, checkboxes, ranges);
      card.classList.toggle("is-hidden", !visible);
      if (visible) visibleCount += 1;
    });

    this.paintRangeFills();

    requestAnimationFrame(function () {
      self.revealVisibleMedia();
    });

    if (this.results) {
      this.results.textContent = visibleCount === 1 ? "1 Result" : visibleCount + " Results";
    }

    if (this.empty) {
      this.empty.classList.toggle("is-visible", visibleCount === 0);
      this.empty.hidden = visibleCount !== 0;
    }

    this.updateOptionCounts(checkboxes, ranges);

    if (!this.skipHistory) {
      this.writeUrl(checkboxes, ranges);
    }

    if (fromUser) {
      const grid = document.getElementById("collection-products-container") || this.layout.querySelector(".collection-filtered__products");
      if (grid && grid.getBoundingClientRect().top < 0) {
        grid.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  };

  EmberCollectionFilters.prototype.paintRangeFill = function (slider) {
    const minInput = slider.querySelector(".range-min");
    const maxInput = slider.querySelector(".range-max");
    const fill = slider.querySelector(".range-fill");
    if (!minInput || !maxInput || !fill) return;
    const limitMin = parseFloat(minInput.min);
    const limitMax = parseFloat(minInput.max);
    const span = limitMax - limitMin;
    if (!span) {
      fill.style.left = "0%";
      fill.style.width = "100%";
      return;
    }
    const min = parseFloat(minInput.value);
    const max = parseFloat(maxInput.value);
    fill.style.left = ((min - limitMin) / span) * 100 + "%";
    fill.style.width = ((max - min) / span) * 100 + "%";
  };

  EmberCollectionFilters.prototype.paintRangeFills = function () {
    const self = this;
    this.panel.querySelectorAll(".range-slider").forEach(function (slider) {
      self.paintRangeFill(slider);
    });
  };

  EmberCollectionFilters.prototype.revealVisibleMedia = function () {
    if (window.AOS && typeof window.AOS.refreshHard === "function") {
      window.AOS.refreshHard();
    }
    this.cards.forEach(function (card) {
      if (card.classList.contains("is-hidden")) return;
      card.querySelectorAll("[data-aos]").forEach(function (el) {
        el.classList.add("aos-animate");
      });
      card.querySelectorAll("img").forEach(function (img) {
        if (img.complete && img.naturalWidth !== 0) return;
        img.loading = "eager";
      });
    });
  };

  EmberCollectionFilters.prototype.updateOptionCounts = function (checkboxes, ranges) {
    const self = this;
    this.panel.querySelectorAll("[data-filter-count]").forEach(function (el) {
      const name = el.getAttribute("data-filter-count");
      const value = el.getAttribute("data-filter-value");
      const others = {};
      Object.keys(checkboxes).forEach(function (key) {
        if (key !== name) others[key] = checkboxes[key];
      });
      let count = 0;
      self.cards.forEach(function (card) {
        if (!self.cardPasses(card, others, ranges, name)) return;
        if (!self.passesCheckboxGroup(card, name, [value])) return;
        count += 1;
      });
      el.textContent = String(count);
    });
  };

  EmberCollectionFilters.prototype.writeUrl = function (checkboxes, ranges) {
    const params = new URLSearchParams(window.location.search);
    const managed = [];
    this.panel.querySelectorAll(".range-slider").forEach(function (slider) {
      if (slider.dataset.name) managed.push(slider.dataset.name);
    });
    checkboxNames(this.panel).forEach(function (name) {
      managed.push(name);
    });
    managed.forEach(function (key) {
      params.delete(key);
    });
    Object.keys(checkboxes).forEach(function (name) {
      params.set(name, checkboxes[name].join(","));
    });
    Object.keys(ranges).forEach(function (name) {
      params.set(name, ranges[name].join(","));
    });
    const keys = Array.from(params.keys()).sort();
    const sorted = new URLSearchParams();
    keys.forEach(function (key) {
      sorted.set(key, params.get(key));
    });
    const search = sorted.toString();
    const next = window.location.pathname + (search ? "?" + search : "") + window.location.hash;
    const current = window.location.pathname + window.location.search + window.location.hash;
    if (next === current) return;
    history.pushState(null, "", next);
  };

  EmberCollectionFilters.prototype.hydrateFromUrl = function () {
    const params = new URLSearchParams(window.location.search);

    this.panel.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      const raw = params.get(input.name);
      const selected = raw ? raw.split(",") : [];
      input.checked = selected.indexOf(input.value) !== -1;
    });

    this.panel.querySelectorAll(".range-slider").forEach(function (slider) {
      const name = slider.dataset.name;
      const minInput = slider.querySelector(".range-min");
      const maxInput = slider.querySelector(".range-max");
      if (!name || !minInput || !maxInput) return;
      const minLimit = parseFloat(minInput.min);
      const maxLimit = parseFloat(minInput.max);
      minInput.value = String(minLimit);
      maxInput.value = String(maxLimit);
      const raw = params.get(name);
      if (!raw) return;
      const parts = raw.split(",");
      if (parts.length !== 2) return;
      const min = parseFloat(parts[0]);
      const max = parseFloat(parts[1]);
      if (Number.isNaN(min) || Number.isNaN(max)) return;
      if (min < minLimit || max > maxLimit || min > max) return;
      minInput.value = String(min);
      maxInput.value = String(max);
    });
  };

  EmberCollectionFilters.prototype.clearAll = function () {
    this.panel.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.checked = false;
    });
    this.panel.querySelectorAll(".range-slider").forEach(function (slider) {
      const minInput = slider.querySelector(".range-min");
      const maxInput = slider.querySelector(".range-max");
      if (!minInput || !maxInput) return;
      minInput.value = minInput.min;
      maxInput.value = maxInput.max;
    });
    this.apply({ fromUser: true });
  };

  function boot(root) {
    if (!root || root.dataset.emberFiltersReady === "true") return;
    root.dataset.emberFiltersReady = "true";
    new EmberCollectionFilters(root);
  }

  function start() {
    if (!isCoffeeTemplate() && !document.getElementById(LAYOUT_ID)) return;
    const root = document.getElementById(LAYOUT_ID);
    if (root) boot(root);
  }

  document.addEventListener("DOMContentLoaded", start);
  document.addEventListener("shopify:section:load", function (event) {
    const root = event.target.querySelector ? event.target.querySelector("#" + LAYOUT_ID) : null;
    if (root) {
      delete root.dataset.emberFiltersReady;
      boot(root);
    } else {
      start();
    }
  });
})();
